/**
 * アクセサリ選択モーダル機能
 */
class AccessorySelector {
  constructor(sectionId) {
    this.sectionId = sectionId;
    this.modal = document.getElementById(`accessory-modal-${sectionId}`);
    this.submitButton = document.getElementById(`ProductSubmitButton-${sectionId}`);
    this.originalFormHandler = null;
    this.originalProductData = null;
    this.eventsInitialized = false; // イベント初期化フラグ

    this.init();
  }

  init() {
    console.log('AccessorySelector initializing with sectionId:', this.sectionId);
    console.log('Modal element:', this.modal);
    console.log('Submit button:', this.submitButton);

    if (!this.modal || !this.submitButton) {
      console.log('Required elements not found, aborting initialization');
      return;
    }

    // より強力なイベントインターセプト
    this.interceptAllEvents();

    // 既存のproduct-formのイベントリスナーを無効化
    this.disableOriginalFormHandler();

    // オリジナルのフォーム送信をインターセプト
    this.interceptFormSubmission();

    // ボタンのクリックイベントも直接インターセプト
    this.interceptButtonClick();

    // モーダルのイベントリスナーを設定
    this.setupModalEvents();

    // 数量変更のイベントリスナーを設定
    this.setupQuantityEvents();
  }

  interceptAllEvents() {
    // document全体でform送信をキャッチ
    document.addEventListener('submit', (e) => {
      if (e.target.id === `product-form-${this.sectionId}`) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        this.originalProductData = new FormData(e.target);
        if (this.isAccessoryCompatibleProduct()) {
          this.showModal();
        } else {
          this.addToCartDirectly();
        }
        return false;
      }
    }, true);

    // document全体でボタンクリックをキャッチ
    document.addEventListener('click', (e) => {
      if (e.target.id === `ProductSubmitButton-${this.sectionId}`) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const productForm = document.querySelector(`#product-form-${this.sectionId}`);
        if (productForm) {
          this.originalProductData = new FormData(productForm);
        }

        if (this.isAccessoryCompatibleProduct()) {
          this.showModal();
        } else {
          this.addToCartDirectly();
        }
        return false;
      }
    }, true);
  }

  disableOriginalFormHandler() {
    const productFormElement = document.querySelector(`product-form[data-section="${this.sectionId}"]`);
    if (productFormElement) {
      // product-formの送信を一時的に無効化
      productFormElement.style.pointerEvents = 'none';
      setTimeout(() => {
        productFormElement.style.pointerEvents = '';
      }, 100);
    }
  }

  interceptFormSubmission() {
    const productForm = document.querySelector(`#product-form-${this.sectionId}`);
    if (!productForm) {
      return;
    }

    // フォーム送信をインターセプト（キャプチャフェーズで最優先実行）
    productForm.addEventListener('submit', (e) => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      // 商品データを保存
      this.originalProductData = new FormData(productForm);

      // アクセサリ対応商品の場合のみモーダルを表示
      if (this.isAccessoryCompatibleProduct()) {
        this.showModal();
      } else {
        // その他の商品は通常通りカートに追加
        this.addToCartDirectly();
      }
    }, true); // キャプチャフェーズで実行
  }

  interceptButtonClick() {
    // 送信ボタンのクリックを直接インターセプト
    this.submitButton.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      // 商品データを取得
      const productForm = document.querySelector(`#product-form-${this.sectionId}`);
      if (productForm) {
        this.originalProductData = new FormData(productForm);
      }

      // アクセサリ対応商品の場合のみモーダルを表示
      if (this.isAccessoryCompatibleProduct()) {
        this.showModal();
      } else {
        this.addToCartDirectly();
      }
    }, true); // キャプチャフェーズで実行
  }

  isAccessoryCompatibleProduct() {
    // data属性から商品情報を取得
    const productInfo = document.querySelector(`#MainProduct-${this.sectionId}`);
    const productType = productInfo?.dataset?.productType || '';
    const productTags = productInfo?.dataset?.productTags || '';
    const productTitle = document.querySelector('.product__title')?.textContent || '';

    // のぼり、スタンド看板、タペストリーに対応
    const isCompatible = productTitle.includes('のぼり') || productTags.includes('のぼり') || productType.includes('のぼり') ||
           productTitle.includes('スタンド看板') || productTags.includes('スタンド看板') || productType.includes('スタンド') ||
           productTitle.includes('タペストリー') || productTags.includes('タペストリー') || productType.includes('タペストリー');

    return isCompatible;
  }

  showModal() {
    if (!this.modal) {
      // モーダルがない場合は直接カートに追加
      this.addToCartDirectly();
      return;
    }

    // のぼり商品についてはサイズが指定の2種類のみモーダルを表示。
    // それ以外のサイズの場合はモーダルを表示せず通常のカート追加へフォールバックする。
    const productType = this.getProductType();
    if (productType === 'nobori') {
      const selectedSize = document.querySelector('input[name*="サイズ"]:checked')?.value || '';
      const isNormal = /(?:50\s*[×xX]\s*150|W50.*H150|50.*150|60\s*[×xX]\s*180|W60.*H180|60.*180)/i.test(selectedSize);
      const isJumbo = /(?:90\s*[×xX]\s*270|W90.*H270|90.*270)/i.test(selectedSize);

      if (!isNormal && !isJumbo) {
        // 対応外サイズならモーダルをスキップして直接カートに追加
        this.addToCartDirectly();
        return;
      }
    }
    // スタンド看板の場合はモーダルをスキップして直接カートに追加
    if (productType === 'stand') {
      const productTitle = document.querySelector('.product__title')?.textContent || '';
      const isOriginalOrder = /オリジナルオーダー/.test(productTitle);

      if (isOriginalOrder) {
        // オリジナルオーダーの場合はモーダルを表示
        // 処理を続行してモーダルを表示する
      } else {
        // それ以外の場合はモーダルをスキップして直接カートに追加
        this.addToCartDirectly();
        return;
      }
    }

    // タペストリー：オリジナルオーダーと屋内向けタペストリーの両方が含まれる場合はモーダルを表示しない
    if (productType === 'tapestry') {
      const productTitle = document.querySelector('.product__title')?.textContent || '';
      const hasOriginalOrder = /オリジナルオーダー/.test(productTitle);
      const hasIndoorTapestry = /屋内向け[\s　]*タペストリー/.test(productTitle);

      if (hasOriginalOrder && hasIndoorTapestry) {
        // 両条件を満たす場合はモーダルをスキップして直接カートに追加
        this.addToCartDirectly();
        return;
      }
    }

    // is-open クラスで表示制御（inline style に依存しない）
    this.modal.classList.add('is-open');
    document.body.style.overflow = 'hidden'; // スクロール禁止

    // 商品タイプに応じてアクセサリオプションを調整
    this.adjustAccessoryOptions();

    // 初期状態をリセット
    this.resetModalState();
    this.updateTotal();
  }

  hideModal() {
    this.modal.classList.remove('is-open');
    document.body.style.overflow = ''; // スクロール復活
  }

  getProductType() {
    // data属性から商品情報を取得
    const productInfo = document.querySelector(`#MainProduct-${this.sectionId}`);
    const productType = productInfo?.dataset?.productType || '';
    const productTags = productInfo?.dataset?.productTags || '';
    const productTitle = document.querySelector('.product__title')?.textContent || '';

    if (productTitle.includes('のぼり') || productTags.includes('のぼり') || productType.includes('のぼり')) {
      return 'nobori';
    } else if (productTitle.includes('スタンド看板') || productTags.includes('スタンド看板') || productType.includes('スタンド')) {
      return 'stand';
    } else if (productTitle.includes('タペストリー') || productTags.includes('タペストリー') || productType.includes('タペストリー')) {
      return 'tapestry';
    }
    return 'nobori'; // デフォルト
  }

  adjustAccessoryOptions() {
    const productType = this.getProductType();
    const poleOption = this.modal.querySelector('.accessory-option:nth-of-type(1)');
    const tankOption = this.modal.querySelector('.accessory-option:nth-of-type(2)');
    const description = this.modal.querySelector('.accessory-modal__description');

    // 要素の存在チェック
    if (!poleOption || !tankOption || !description) {
      return;
    }

    // 商品タイプに応じてオプション表示を調整
    switch (productType) {
      case 'nobori':
        // のぼり: ポール・注水台両方表示
        poleOption.style.display = 'block';
        tankOption.style.display = 'block';

        // タイトルを調整
        description.textContent = 'ポール・注水台をカートに追加しますか？';
        // サイズ判定（通常／ジャンボ）
        const selectedSize = document.querySelector('input[name*="サイズ"]:checked')?.value || '';
        const isJumbo = /(?:90\s*[×xX]\s*270|W90.*H270|90.*270)/i.test(selectedSize);

        // テキスト要素を探すヘルパー
        const setOptionText = (optionEl, text) => {
          if (!optionEl) return;
          const titleEl = optionEl.querySelector('.accessory-option__text') || optionEl.querySelector('.accessory-option__title') || optionEl.querySelector('.accessory-option__label');
          if (titleEl) titleEl.textContent = text;
        };

        setOptionText(poleOption, isJumbo ? 'ポール（ジャンボ対応）' : 'ポール（通常・コンパクト対応）');
        setOptionText(tankOption, isJumbo ? '注水台 21L（ジャンボ対応）' : '注水台 17L（通常・コンパクト対応）');
        break;

      case 'stand':
        // スタンド看板: 注水台のみ表示
        poleOption.style.display = 'none';
        tankOption.style.display = 'block';

        // タイトルを調整
        description.textContent = '注水台をカートに追加しますか？';
        // スタンドは通常サイズを想定（17L）
        const setOptionTextStand = (optionEl, text) => {
          if (!optionEl) return;
          const titleEl = optionEl.querySelector('.accessory-option__text') || optionEl.querySelector('.accessory-option__title') || optionEl.querySelector('.accessory-option__label');
          if (titleEl) titleEl.textContent = text;
        };
        setOptionTextStand(tankOption, '注水台 17L（通常・コンパクト対応）');
        break;

      case 'tapestry':
        // タペストリー: ポール（上下）のみ表示
        poleOption.style.display = 'block';
        tankOption.style.display = 'none';

        // タイトルを調整
        description.textContent = '上下ポールをカートに追加しますか？';
        break;
            // タイトルを調整
            description.textContent = '上下ポールをカートに追加しますか？';
            // タペストリー用はセット表記にしつつ、通常表記の名称に合わせる
            const poleTitleEl = poleOption.querySelector('.accessory-option__text') || poleOption.querySelector('.accessory-option__title') || poleOption.querySelector('.accessory-option__label');
            if (poleTitleEl) poleTitleEl.textContent = 'ポール（通常・コンパクト対応）';
    }
  }

  resetModalState() {
    // 数量入力を0にリセット
    const qtyInputs = this.modal.querySelectorAll('.accessory-qty-input');
    qtyInputs.forEach(input => {
      input.value = 0;
      // ボタンの状態も更新
      this.updateQuantityButtonStates(input);
    });
  }

  setupModalEvents() {
    // 閉じるボタン・オーバーレイ（モーダルを閉じるだけ）
    const closeBtn = this.modal.querySelector('.accessory-modal__close');
    const overlay = this.modal.querySelector('.accessory-modal__overlay');

    [closeBtn, overlay].forEach(element => {
      if (element) {
        // 既存のイベントリスナーをクリアしてから新規追加
        element.onclick = () => this.hideModal();
      }
    });

    // キャンセルボタン（追加しない - メイン商品のみカートに追加してカート画面へ）
    const cancelBtn = this.modal.querySelector('.accessory-modal__cancel');
    if (cancelBtn) {
      cancelBtn.onclick = () => this.addMainProductAndGoToCart();
    }

    // カートに追加ボタン
    const addBtn = this.modal.querySelector('.accessory-modal__add-to-cart');
    if (addBtn) {
      // 既存のイベントリスナーをクリアしてから新規追加
      addBtn.onclick = () => this.addToCartWithAccessories();
    }
  }



  setupQuantityEvents() {
    // 一度だけ初期化する
    if (this.eventsInitialized) {
      return;
    }

    // 既存のイベントリスナーをすべて削除
    const qtyInputs = this.modal.querySelectorAll('.accessory-qty-input');
    qtyInputs.forEach(input => {
      // 既存のイベントリスナーをクローンして置き換え
      const newInput = input.cloneNode(true);
      input.parentNode.replaceChild(newInput, input);

      // 新しいinputイベントリスナーを追加
      newInput.addEventListener('input', (e) => {
        if (e.isTrusted) {
          this.updateTotal();
          this.updateQuantityButtonStates(newInput);
        }
      });
    });

    // +/-ボタンのイベントリスナーを追加
    const quantityButtons = this.modal.querySelectorAll('.quantity__button');
    quantityButtons.forEach(button => {
      // 既存のイベントリスナーをクローンで置き換え
      const newButton = button.cloneNode(true);
      button.parentNode.replaceChild(newButton, button);

      // 新しいボタンイベントリスナーを追加
      newButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const targetId = newButton.dataset.target;
        const input = document.getElementById(targetId);

        if (!input) return;

        const currentValue = parseInt(input.value) || 0;
        const min = parseInt(input.min) || 0;
        const max = parseInt(input.max) || 99;

        // 値を直接変更
        if (newButton.name === 'plus') {
          if (currentValue < max) {
            input.value = currentValue + 1;
          }
        } else if (newButton.name === 'minus') {
          if (currentValue > min) {
            input.value = currentValue - 1;
          }
        }

        // 手動で更新処理を呼び出し
        this.updateTotal();
        this.updateQuantityButtonStates(input);
      });
    });

    // 初期化フラグをセット
    this.eventsInitialized = true;
  }

  updateQuantityButtonStates(input) {
    const targetId = input.id;
    const currentValue = parseInt(input.value) || 0;
    const min = parseInt(input.min) || 0;
    const max = parseInt(input.max) || 99;

    // 同じdata-targetを持つボタンを取得
    const minusButton = this.modal.querySelector(`button[name="minus"][data-target="${targetId}"]`);
    const plusButton = this.modal.querySelector(`button[name="plus"][data-target="${targetId}"]`);

    if (minusButton) {
      minusButton.disabled = currentValue <= min;
    }
    if (plusButton) {
      plusButton.disabled = currentValue >= max;
    }
  }

  updateTotal() {
    const poleQty = parseInt(this.modal.querySelector('input[name="pole_qty"]')?.value || 0);
    const tankQty = parseInt(this.modal.querySelector('input[name="tank_qty"]')?.value || 0);
    const productType = this.getProductType();

    let polePrice = 0;
    let tankPrice = 0;
    let poleUnit = '/本';
    let tankUnit = '/台';

    switch (productType) {
      case 'nobori':
        // のぼり: サイズから通常/ジャンボを判定。W60×H180 -> 通常、W90×H270 -> ジャンボ
        const selectedSize = document.querySelector('input[name*="サイズ"]:checked')?.value || '';
        const isNormal = /(?:50\s*[×xX]\s*150|W50.*H150|50.*150|60\s*[×xX]\s*180|W60.*H180|60.*180)/i.test(selectedSize);
        const isJumbo = /(?:90\s*[×xX]\s*270|W90.*H270|90.*270)/i.test(selectedSize);

        if (isNormal) {
          polePrice = 660;
          tankPrice = 3190;
        } else if (isJumbo) {
          polePrice = 1320;
          tankPrice = 3520;
        } else {
          // 対応外サイズはモーダル表示されないはずだが、念のため単価は0にする
          polePrice = 0;
          tankPrice = 0;
        }
        break;

      case 'stand':
        // スタンド看板: 注水台のみ、固定価格
        polePrice = 0;
        tankPrice = 3190;
        break;

      case 'tapestry':
        // タペストリー: 上下ポールのみ、固定価格
        polePrice = 1320;
        tankPrice = 0;
        poleUnit = '/セット'; // 上下ポールセット
        break;
    }

    const total = (poleQty * polePrice) + (tankQty * tankPrice);

    // 表示更新
    const totalElement = this.modal.querySelector('.accessory-total__price');
    if (totalElement) {
      totalElement.textContent = `+${total.toLocaleString()}円`;
    }

    // 単価表示も更新
    const poleOption = this.modal.querySelector('.accessory-option:nth-of-type(1)');
    const tankOption = this.modal.querySelector('.accessory-option:nth-of-type(2)');

    const polePriceElement = poleOption?.querySelector('.accessory-unit-price');
    const tankPriceElement = tankOption?.querySelector('.accessory-unit-price');

    if (polePriceElement && polePrice > 0) {
      polePriceElement.textContent = `+${polePrice.toLocaleString()}円${poleUnit}`;
      polePriceElement.setAttribute('data-unit-price', polePrice);
    } else if (polePriceElement) {
      polePriceElement.textContent = `+0円${poleUnit}`;
    }

    if (tankPriceElement && tankPrice > 0) {
      tankPriceElement.textContent = `+${tankPrice.toLocaleString()}円${tankUnit}`;
      tankPriceElement.setAttribute('data-unit-price', tankPrice);
    } else if (tankPriceElement) {
      tankPriceElement.textContent = `+0円${tankUnit}`;
    }
  }

  async addToCartWithAccessories() {
    const poleQty = parseInt(this.modal.querySelector('input[name="pole_qty"]')?.value || 0);
    const tankQty = parseInt(this.modal.querySelector('input[name="tank_qty"]')?.value || 0);

    try {
      // メイン商品をカートに追加
      const mainRes = await this.addMainProductToCart();

      // アクセサリをカートに追加
      if (poleQty > 0) {
        try {
          await this.addAccessoryToCart('pole', poleQty);
        } catch (err) {
          console.error('AccessorySelector: pole accessory add failed, continuing:', err.message);
          // エラーがあっても続行する
        }
      }

      if (tankQty > 0) {
        try {
          await this.addAccessoryToCart('tank', tankQty);
        } catch (err) {
          console.error('AccessorySelector: tank accessory add failed, continuing:', err.message);
          // エラーがあっても続行する
        }
      }

      // 成功時の処理
      this.hideModal();
      this.showSuccessMessage();
      // カート画面へ遷移して内容を確認できるようにする
      window.location = window.routes?.cart_url || '/cart';

    } catch (error) {
      console.error('カート追加エラー:', error.message || error);
      this.showErrorMessage('カートへの追加に失敗しました。もう一度お試しください。');
    }
  }

  async addMainProductAndGoToCart() {
    // 「追加しない」ボタン用 - メイン商品のみをカートに追加してカート画面へ遷移
    try {
      // メイン商品をカートに追加
      await this.addMainProductToCart();

      // 成功時の処理
      this.hideModal();
      this.showSuccessMessage();
      // カート画面へ遷移
      window.location = window.routes?.cart_url || '/cart';

    } catch (error) {
      console.error('カート追加エラー:', error.message || error);
      this.showErrorMessage('カートへの追加に失敗しました。もう一度お試しください。');
    }
  }

  async addMainProductToCart() {
    const formData = this.originalProductData;

    // FormData を JSON に変換
    const jsonData = {};
    for (const [key, value] of formData.entries()) {
      jsonData[key] = value;
    }

    // FormData の variant ID を確認し、必要に応じて更新
    if (window.selectedVariant && window.selectedVariant.id) {
      jsonData.id = window.selectedVariant.id;
    }

    // まず JSON で試す
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(jsonData)
      });

      if (response.ok) {
        const json = await response.json();
        return json;
      }

      // JSON で失敗した場合は URLSearchParams で再試行
      const urlEncodedResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(jsonData)
      });

      if (urlEncodedResponse.ok) {
        const json = await urlEncodedResponse.json();
        return json;
      }

      // 両方失敗した場合
      const errorText = await urlEncodedResponse.text();
      console.error('AccessorySelector: addMainProductToCart both methods failed response body:', errorText);
      throw new Error(`メイン商品の追加に失敗 (Status: ${urlEncodedResponse.status})`);

    } catch (error) {
      console.error('AccessorySelector: addMainProductToCart error:', error.message);
      throw error;
    }
  }

  async addAccessoryToCart(type, quantity) {
    // 関連商品のバリアントIDを取得（非同期）
    const allVariantIds = await this.getAccessoryVariantIds();

    // type に応じた key を構築
    let variantIdKey = null;
    if (type === 'pole') {
      const productType = this.getProductType();
      if (productType === 'tapestry') {
        // タペストリー用は上下ポールセットの固定バリアント
        variantIdKey = 'pole_tapestry';
      } else {
        const selectedSize = document.querySelector('input[name*="サイズ"]:checked')?.value || '';
        const isJumbo = /(?:90\s*[×xX]\s*270|W90.*H270|90.*270)/i.test(selectedSize);
        variantIdKey = isJumbo ? 'pole_jumbo' : 'pole_normal';
      }
    } else if (type === 'tank') {
      const productType = this.getProductType();
      if (productType === 'stand') {
        variantIdKey = 'tank_stand';
      } else {
        const selectedSize = document.querySelector('input[name*="サイズ"]:checked')?.value || '';
        const isJumbo = selectedSize.includes('270');
        variantIdKey = isJumbo ? 'tank_jumbo' : 'tank_normal';
      }
    }

    let variantId = allVariantIds[variantIdKey];

    if (!variantId) {
      // アクセサリが見つからない場合はスキップ（エラーにしない）
      return;
    }

    // バリアント ID を整数に変換（Shopify API は整数を期待）
    const numericVariantId = parseInt(variantId, 10);

    // Shopify Cart API は variant ID を "id" として受け付ける
    const requestBody = {
      items: [{
        id: numericVariantId,
        quantity: parseInt(quantity, 10)
      }]
    };

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody)
      });

// //       console.log('AccessorySelector: addAccessoryToCart response status', response.status);

      if (response.ok) {
        const json = await response.json();
// //         console.log('AccessorySelector: addAccessoryToCart response json', json);
        return json;
      }

      // JSON で 422 が返った場合は文字列形式で再試行
      if (response.status === 422) {
// //         console.log('AccessorySelector: 422 エラー - 文字列形式で再試行');
        const stringRequestBody = {
          items: [{
            id: String(numericVariantId),
            quantity: parseInt(quantity, 10)
          }]
        };
// //         console.log('AccessorySelector: retry request body (string):', JSON.stringify(stringRequestBody));

        const retryResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(stringRequestBody)
        });

// //         console.log('AccessorySelector: retry response status', retryResponse.status);

        if (retryResponse.ok) {
          const json = await retryResponse.json();
// //           console.log('AccessorySelector: retry response json', json);
          return json;
        }

        const retryText = await retryResponse.text();
        console.error('AccessorySelector: retry failed response body:', retryText);
        throw new Error(`${type} の追加に失敗 (Status: ${retryResponse.status}) - 文字列形式も失敗`);
      }

      const text = await response.text();
      console.error(`AccessorySelector: ${type} の追加に失敗 response body:`, text);

      // 422 エラーの場合は詳細情報をログ
      if (response.status === 422) {
        console.error('AccessorySelector: 422 Unprocessable Entity - variant ID or quantity が無効な可能性があります', {
          type,
          variantIdKey,
          variantId: numericVariantId,
          quantity: parseInt(quantity, 10)
        });
      }

      throw new Error(`${type} の追加に失敗 (Status: ${response.status})`);

    } catch (error) {
      console.error('AccessorySelector: addAccessoryToCart error:', error.message);
      throw error;
    }
  }

  async getVariantIdFromProductCode(productCode) {
    // このメソッドは廃止されました
    // getAccessoryVariantIds() から直接バリアントIDを取得してください
//     console.warn('AccessorySelector: getVariantIdFromProductCode is deprecated - use getAccessoryVariantIds() instead');
    return null;
  }

  async getAccessoryVariantIds() {
    // related_products-1 コレクションから variant ID を取得
    try {
      // SKU と variant ID のマッピング（確定）
      const skuToVariantMap = {
        '8001': 52789497266541,  // のぼり用ポール（白）通常用
        '8002': 52789497299309,  // のぼり用ポール（白）ジャンボ用
        '8003': 52789497332077,  // 注水台（17リットル）通常用
        '8004': 52789497397613,  // 注水台（21リットル）ジャンボ用
        '8005': 52789497528685,  // 注水台 スタンド看板用
        '8006': 52789497626989   // 上下ポールセット タペストリー用
      };

      // キー名へのマッピング
      const skuToKeyMap = {
        '8001': 'pole_normal',
        '8002': 'pole_jumbo',
        '8003': 'tank_normal',
        '8004': 'tank_jumbo',
        '8005': 'tank_stand',
        '8006': 'pole_tapestry'
      };

      const variantIds = {};

      // related_products-1 から商品を確認（検証用）
      try {
        const res = await fetch('/collections/related_products-1/products.json?limit=250');
        if (res.ok) {
          const data = await res.json();
          const products = data.products || [];
//           console.log(`AccessorySelector: getAccessoryVariantIds - related_products-1 found ${products.length} products`);

          // SKU マッピングから variant ID を取得
          for (const product of products) {
            for (const variant of product.variants || []) {
              const sku = variant.sku || '';
              if (skuToVariantMap[sku]) {
                const key = skuToKeyMap[sku];
                variantIds[key] = variant.id;
//                 console.log(`AccessorySelector: Found ${key} (SKU ${sku}) - variant id: ${variant.id}`);
              }
            }
          }
        }
      } catch (e) {
        console.error('AccessorySelector: Error fetching related_products-1:', e);
      }

      // 見つからなかったものは直接マッピングから取得
      for (const [sku, key] of Object.entries(skuToKeyMap)) {
        if (!variantIds[key]) {
          variantIds[key] = skuToVariantMap[sku];
//           console.log(`AccessorySelector: Using hardcoded mapping for ${key} (SKU ${sku}) - variant id: ${skuToVariantMap[sku]}`);
        }
      }

// //       console.log('AccessorySelector: getAccessoryVariantIds result', variantIds);
      return variantIds;

    } catch (error) {
      console.error('AccessorySelector: getAccessoryVariantIds error', error);

      // フォールバック：確定した variant ID を使用
// //       console.log('AccessorySelector: Using fallback hardcoded variant IDs');
      return {
        'pole_normal': 52789497266541,
        'pole_jumbo': 52789497299309,
        'tank_normal': 52789497332077,
        'tank_jumbo': 52789497397613,
        'tank_stand': 52789497528685,
        'pole_tapestry': 52789497626989
      };
    }
  }



  async addToCartDirectly() {
    // 通常のカート追加処理
    const productForm = document.querySelector(`#product-form-${this.sectionId}`);
    if (!productForm) return;

    const formData = new FormData(productForm);

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData)
      });

      if (response.ok) {
        this.showSuccessMessage();
//         console.debug('AccessorySelector: addToCartDirectly success, redirecting to cart');
        window.location = window.routes?.cart_url || '/cart';
      } else {
        throw new Error('カート追加に失敗');
      }
    } catch (error) {
      console.error('カート追加エラー:', error);
      this.showErrorMessage('カートへの追加に失敗しました。');
    }
  }

  showSuccessMessage() {
    // カート追加成功時の処理（通知表示など）
//     console.log('カートに追加されました');

    // 既存のカート通知システムがあれば利用
    const cartNotification = document.querySelector('cart-notification');
    if (cartNotification) {
      cartNotification.renderContents({
        sections: {
          'cart-notification-product': document.querySelector('[id*="cart-notification"]')?.innerHTML || ''
        }
      });
    }
  }

  showErrorMessage(message) {
    // エラーメッセージ表示
    console.error('AccessorySelector Error:', message);

    // 既存のエラー通知システムがあれば利用、なければコンソールログのみ
    const errorNotification = document.querySelector('.notification-error');
    if (errorNotification) {
      errorNotification.textContent = message;
      errorNotification.style.display = 'block';
      setTimeout(() => {
        errorNotification.style.display = 'none';
      }, 5000);
    }
  }
}

// ページロード時に初期化
document.addEventListener('DOMContentLoaded', () => {
  // 複数の方法でproduct sectionを検索
  let productSection = null;
  let sectionId = null;

  // 方法1: data-section属性を持つmain-product関連のセクション
  productSection = document.querySelector('[data-section*="main-product"]');
  if (productSection) {
    sectionId = productSection.dataset.section;
  }

  // 方法2: product-info要素
  if (!productSection) {
    productSection = document.querySelector('product-info');
    if (productSection) {
      sectionId = productSection.dataset.section;
    }
  }

  // 方法3: template--で始まるdata-section属性
  if (!productSection) {
    productSection = document.querySelector('[data-section^="template--"]');
    if (productSection) {
      sectionId = productSection.dataset.section;
    }
  }

  // 方法4: MainProduct-で始まるID
  if (!productSection) {
    productSection = document.querySelector('[id^="MainProduct-"]');
    if (productSection) {
      sectionId = productSection.id.replace('MainProduct-', '');
    }
  }

  if (productSection && sectionId) {
    new AccessorySelector(sectionId);
  }
});
